import clsx from 'clsx'
import { memo } from 'react'

import Arrow from '@/atoms/Arrow/Arrow'
import Avatar from '@/atoms/Avatar/Avatar'
import Link from '@/atoms/Link'
import Creator from '@/ts/Creator'

function CreatorBar(props: CreatorBarProps) {
  const { className, creator, onBack } = props
  const { nickname, avatar, slug } = creator

  return (
    <div className={clsx('relative py-3 md:py-4 bg-violet-5', className)}>
      <div className="flex items-center space-x-4 md:space-x-8">
        {onBack && (
          <button
            className="transition-transform focus:outline-none hover:-translate-x-1 hover:text-sbtviolet-600"
            onClick={onBack}
          >
            <Arrow direction="left" variant="primary" className="w-6" />
          </button>
        )}

        <Link
          className="flex items-center space-x-4 hover:underline"
          href={{
            pathname: '/creators/[slug]',
            query: { slug },
          }}
        >
          <Avatar nickname={nickname} src={avatar} size={40} />
          <h2 className="text-sm font-medium md:text-xl">{nickname}</h2>
        </Link>
      </div>
    </div>
  )
}

interface CreatorBarProps {
  className?: string
  creator: Creator
  onBack?(): void
}

export default memo(CreatorBar)
